module.exports = __webpack_public_path__ + "kit/docs/img/mountains.c4a69365.png";